import React, { useState, useEffect, useContext } from "react";
import { useForm } from 'react-hook-form';
import './rightDetails.scss';
import { IoIosSend } from "react-icons/io";
import { useParams } from 'react-router-dom';
import candidateApi from "../../services/candidateApi";
import { AuthContext } from "../../context/AuthContext";
import { toast } from "react-toastify";

export const Comments = () => {
  let { id } = useParams();
  const [comments, setComments] = useState([]);
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const { candidateIdValue, setCandidateIdValue } = useContext(AuthContext);
// Fetch comments from the API
const fetchComments = async () => {
  try {
    // debugger;
    if (!id){
      id=candidateIdValue;
    }
    const response = await candidateApi.getCommentsForCandidate(id); // Fetch API call
    if (response?.status === 200 && Array.isArray(response.data)) {
      setComments(response.data); // Directly use the array from response.data
      console.log("Fetched comments:", response.data); // Log to confirm
    } else {
      console.error("Failed to fetch comments or invalid data format.");
    }
  } catch (error) {
    toast.error("Error fetching comments", {
              position: "top-right", 
              autoClose: 2000,
            });
    console.error("Error fetching comments:", error.message);
  }
};

useEffect(() => {
  fetchComments(); 
}, [id]);


  const onSubmit = async (data) => {
    const requestData = {
      // formData: {
        candidateId: id, // ID of the candidate
        comment: data.comment // The comment text
      // }
    }; 
    // data.candidateId=id;
   
    try {
      const response = await candidateApi.insertCommentForCandidate(requestData);
      console.log("Comment submitted successfully:", response);
      if (response.status === 200) {
        const newComment = response.data.comment;  
        setComments((prevComments) => [newComment, ...prevComments]);  
        reset();
        toast.success("Comment submitted sucessfully", {
                  position: "top-right", 
                  autoClose: 2000,
                });
      }

    } catch (error) {
      toast.error("Error submitting comments", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error submitting form:", error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert the date string to a Date object
    const options = {
      day: '2-digit', // Two-digit day
      month: 'short', // Abbreviated month name
      year: 'numeric', // Full year
    };  
    return date.toLocaleDateString('en-GB', options); // Format the date in 'DD MMM YYYY' format
  };


  return (
    <div className="comment-wrapper">
      <h5 className="mb-3">
        Comments
      </h5>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="comment-form position-relative">
          <textarea className="form-control" placeholder="Please enter your comments" id="comment"
                          {...register("comment", {
                            required: "Comment is required",
                          })}></textarea>
          <button type="submit" className="btn btn-primary font-size-larger p-2 py-0 position-absolute comment-btn">
            <IoIosSend />
          </button>
        </div>
        {errors.comment && <p className="text-danger">{errors.comment.message}</p>}
      </form>   
      <div className="comment-thread mt-4 d-flex flex-column gap-3">
        {/* comment repeat start here */}
        {comments.length > 0 ? (
          comments.map((comment) => (
        <div className="comment">
          <h6>{comment.firstName} {comment.lastName}</h6>
          <div className="d-flex gap-2 comment-head mb-1">
            <p className="mb-0">
              {comment.roleName}
            </p>
            <span className="ms-auto">
              {formatDate(comment.createdAt)}
            </span>
          </div>
          <p className="mb-0">
          {comment.comment}
          </p>
          <hr />
        </div>
          ))
        ) : (
          <p>No comments yet. Be the first to comment!</p>
        )}
        {/* comment repeat ends here */}
      </div>
    </div>
  );
}

